// import { combineReducers, createStore } from "redux";

// import restaurantsReducer from "./restaurants/reducer";

// const enhancer = window.__REDUX_DEVTOOLS_EXTENSION__
//   ? window.__REDUX_DEVTOOLS_EXTENSION__()
//   : (x) => x;

// const store = createStore(
//   combineReducers({
//     restaurants: restaurantsReducer,
//   }),
//   enhancer
// );

// export default store;

import { createStore, applyMiddleware, compose } from "redux";

import ReduxThunk from "redux-thunk";
import reducer from "./rootReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(applyMiddleware(ReduxThunk));

const store = createStore(reducer, enhancer);

export default store;
